export default __webpack_public_path__ + "static/media/ic-dataops.b7be73f5.svg";